import React from 'react'
import My from './my';
import Other from './other';
import { useRef, useEffect, useState } from 'react';

const Index = ({openChatBox,messages}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const messagesEndRef = useRef(null)
    const [filteredMessage,setFilteredMessages] = useState([]);
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }
    function getUnique(arr, index) {
        const unique = arr
             .map(e => e[index])
      
             // store the keys of the unique objects
             .map((e, i, final) => final.indexOf(e) === i && i)
        
             // eliminate the dead keys & store unique objects
            .filter(e => arr[e]).map(e => arr[e]);      
      
         return unique;
    }
    useEffect(() => {
        setFilteredMessages(getUnique(messages,'id'));
    }, [messages]);
    useEffect(()=>{
        scrollToBottom()
    },[filteredMessage])
  return (
    <div className='open_chatbox_messages'>
        {
            [...filteredMessage].reverse().map((message,index)=>{
                return(
                    <>
                    {message.room == openChatBox.id &&
                        <div className='message_box_wrapper' key={index}>
                            {message.userid == User.id &&
                                <My message={message}/>
                            }
                            {message.userid != User.id &&
                                <Other message={message}/>
                            }
                        </div>
                    }
                    </>
                )
            })
        }
        <div ref={messagesEndRef} />
    </div>
  )
}

export default Index
